/* eslint-disable import/no-cycle */
import React from 'react'

import { CtaButton, Image } from '..'
import { Content, Heading } from '../Typography'
import {
  experienceMobileCard,
  experiencMobileCardContent,
  mobileCardImage,
} from './AccordionItem.module.css'

const UspAccordion = ({ content, cta, image, items, title, withoutTitle }) => {
  return (
    <div className={experienceMobileCard}>
      {image && (
        <Image
          alt={image.altText || 'Kliniken Image'}
          className={mobileCardImage}
          loading="lazy"
          src={image.node.localFile.childImageSharp}
        />
      )}
      <div className={experiencMobileCardContent}>
        {title && !withoutTitle && <Heading>{title}</Heading>}
        {content && <Content renderContent={content} />}
        {items && items.map((subItem) => subItem)}
        {cta && <CtaButton {...cta} />}
      </div>
    </div>
  )
}

export default UspAccordion
